import React from "react";

const ButtonRenderer = ({
  object,
  dataJson,
  styleJson,
  commonStyle,
  handleMouseDown,
  renderSelectionHandles,
  isDragging,
  onButtonAction,
}) => {
  const selectedHandles = renderSelectionHandles();

  const handleLocalMouseDown = (e) => {
    e.stopPropagation();
    handleMouseDown?.(e);
  };

  const handleClick = (e) => {
    e.stopPropagation();

    // اگر ctrl/cmd برای multi-select زده شده، اکشن دکمه اجرا نشود
    if (e.ctrlKey || e.metaKey) {
      return;
    }

    if (!isDragging && typeof onButtonAction === "function") {
      onButtonAction(object);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={handleLocalMouseDown}
      style={{
        position: "absolute",
        ...commonStyle,
        fontSize: styleJson.fontSize || 14,
        fontWeight: styleJson.fontWeight || "normal",
        backgroundColor: styleJson.backgroundColor || "#16a34a",
        color: styleJson.color || "#ffffff",
        border: "none",
        borderRadius: styleJson.borderRadius || 8,
        outline: selectedHandles ? "2px solid #2563eb" : "none",
        outlineOffset: selectedHandles ? "2px" : "0",
      }}
    >
      {dataJson.label || object.name || "Button"}
      {selectedHandles}
    </button>
  );
};

export default ButtonRenderer;